var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show && _vm.price)?_c('div',{staticClass:"price"},[_c('span',{staticClass:"price-symbol"},[_vm._v(_vm._s(_vm.symbol))]),_c('span',{staticClass:"price-number"},[_vm._v(_vm._s(_vm.price))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }